import { IWorkflowTemplateVersionActionResult } from '@commenda/types';
import { fetcher, messageFromApiErrorResponse } from '@commenda/utils';
import { BASE_URL } from './helpers';

export async function deleteWorkflowTemplateVersion(
  workflowTemplateVersionId: string
): Promise<IWorkflowTemplateVersionActionResult> {
  try {
    const res = await fetcher(
      `${BASE_URL}/version/${workflowTemplateVersionId}`,
      {
        method: 'DELETE',
      }
    );

    if (!res.ok) {
      return {
        success: false,
        error: await messageFromApiErrorResponse(
          res,
          'Could not discard this draft.'
        ),
      };
    }

    return { success: true };
  } catch {
    return {
      success: false,
      error: 'Could not reach the server to discard this draft.',
    };
  }
}
